/*!

=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import AllAds from "./components/Ads/AllAds.js";
import VerifyBankPage from "./components/BankDetails/VerifyBankPage.js";
import ListFeedbacks from "./components/Feedbacks/ListFeedbacks.js";
import ViewFeedback from "./components/Feedbacks/ViewFeedback.js";
import CreateGiftcards from "./components/Giftcards/CreateGiftcards.js";
import GoogleScreen from "./components/GoogleScreen.js";
import TotalOrders from "./components/Orders/TotalOrders.js";
import User_Specific_order from "./components/Orders/User_Specific_order.js";
import ViewOrder from "./components/Orders/ViewOrder.js";
import SingleOrderProductView from "./components/Products/SingleOrderProductView.js";
import TotalProducts from "./components/Products/TotalProducts.js";
import User_Specific_Products from "./components/Products/User_Specific_products.js";
import ViewProduct from "./components/Products/ViewProduct.js";
import ReportedUsers from "./components/Reportedusers/ReportedUsers.js";
import SingleReportCase from "./components/Reportedusers/SingleReportCase.js";
import SingleUserMonthlyEarning from "./components/SingleUser/SingleUserMonthlyEarning.js";
import SingleUserMonthlyEarningByMonth from "./components/SingleUser/SingleUserMonthlyEarningByMonth.js";
import SingleUserProfile from "./components/SingleUser/SingleUserProfile.js";
import VerificationPage from "./components/Verifications/VerificationPage.js";
import All_Users_beyown from "./views/All_Users_beyown.js";
import Dashboard from "./views/Dashboard.js";
import Icons from "./views/Icons.js";
import Map from "./views/Map.js";
import Notifications from "./views/Notifications.js";
import Rtl from "./views/Rtl.js";
import TableList from "./views/TableList.js";
import Typography from "./views/Typography.js";
import UserProfile from "./views/UserProfile.js";


var routes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-chart-pie-36",
    component: Dashboard,
    layout: "/admin"
  },
  {
    path: "/users/total-beyown-users",
    name: "List ALL Users",
    rtlName: "الرموز",
    icon: "tim-icons icon-single-02",
    component: All_Users_beyown,
    layout: "/admin"
  },

  {
    path: "/icons",
    name: "Icons",
    rtlName: "الرموز",
    icon: "tim-icons icon-atom",
    component: Icons,
    layout: "/admin"
  },
  {
    path: "/map",
    name: "Map",
    rtlName: "خرائط",
    icon: "tim-icons icon-pin",
    component: Map,
    layout: "/admin"
  },
  {
    path: "/notifications",
    name: "Notifications",
    rtlName: "إخطارات",
    icon: "tim-icons icon-bell-55",
    component: Notifications,
    layout: "/admin"
  },
  {
    path: "/user-profile",
    name: "User Profile",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: UserProfile,
    layout: "/admin"
  },
  {
    path: "/Reported-Users/SingleCase/:id",
    name: "Reported Users",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: SingleReportCase,
    layout: "/admin"
  },
  {
    path: "/SingleUser/MonthlyEarnings/:id/:month",
    name: "monthlyEarnings",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: SingleUserMonthlyEarningByMonth,
    layout: "/admin"
  },
  {
    path: "/SingleUser/MonthlyEarnings/:id",
    name: "monthlyEarnings",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: SingleUserMonthlyEarning,
    layout: "/admin"
  },
  {
    path: "/Reported-Users",
    name: "Reported Users",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: ReportedUsers,
    layout: "/admin"
  },

  {
    path: "/verificationReqs",
    name: "User Verification Requests",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: VerificationPage,
    layout: "/admin"
  },
  {
    path: "/userAds",
    name: "Ads",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: AllAds,
    layout: "/admin"
  },
  {
    path: "/CreateGiftCards/:id",
    name: "Ads",
    rtlName: "ملف تعريفي للمستخدم",
    icon: "tim-icons icon-single-02",
    component: CreateGiftcards,
    layout: "/admin"
  },

  // {
  //   path: "/tables",
  //   name: "Table List",
  //   rtlName: "قائمة الجدول",
  //   icon: "tim-icons icon-puzzle-10",
  //   component: TableList,
  //   layout: "/admin"
  // },
  // {
  //   path: "/typography",
  //   name: "Typography",
  //   rtlName: "طباعة",
  //   icon: "tim-icons icon-align-center",
  //   component: Typography,
  //   layout: "/admin"
  // },
  // {
  //   path: "/rtl-support",
  //   name: "RTL Support",
  //   rtlName: "ار تي ال",
  //   icon: "tim-icons icon-world",
  //   component: Rtl,
  //   layout: "/rtl"
  // },
  {
    path: "/total-beyown-users/single_user/:id",
    name: "Single User",
    rtlName: "ار تي ال",
    icon: "tim-icons icon-world",
    component: SingleUserProfile,
    layout: "/admin"
  },
  {
    path: "/Total-Orders/Single-Order/ViewProduct/:id",
    name: "Single Product View By OrdersView",
    rtlName: "ار تي ال",
    icon: "",
    component: SingleOrderProductView,
    layout: "/admin"
  },
  {
    path: "/Total-Orders/Single-Order/:id",
    name: "Single Order",
    rtlName: "ار تي ال",
    icon: "",
    component: ViewOrder,
    layout: "/admin"
  },
  {
    path: "/Total-Orders/:id/All-Orders",
    name: "User Specific Orders",
    rtlName: "ار تي ال",
    icon: "",
    component: User_Specific_order,
    layout: "/admin"
  },
  {
    path: "/Total-Orders",
    name: "Total Orders",
    rtlName: "ار تي ال",
    icon: "tim-icons icon-world",
    component: TotalOrders,
    layout: "/admin"
  },

  {
    path: "/Total-Products/Single-Product/:id",
    name: "Single Product",
    rtlName: "ار تي ال",
    icon: "",
    component: ViewProduct,
    layout: "/admin"
  },
  {
    path: "/Total-Products/:id/All-Products",
    name: "User Specific Products",
    rtlName: "ار تي ال",
    icon: "",
    component: User_Specific_Products,
    layout: "/admin"
  },
  {
    path: "/Total-Products",
    name: "Total Products",
    rtlName: "",
    icon: "tim-icons icon-world",
    component: TotalProducts,
    layout: "/admin"
  },
  {
    path: "/users/bank-details/requests",
    name: "List Bank details requuests",
    rtlName: "الرموز",
    icon: "tim-icons icon-single-02",
    component: VerifyBankPage,
    layout: "/admin"
  },
  {
    path: "/Feed-backs/single/:id",
    name: "Feedbacks_Single",
    rtlName: "ار تي ال",
    icon: "tim-icons icon-world",
    component: ViewFeedback,
    layout: "/admin"
  },

  {
    path: "/Feed-backs",
    name: "Feedbacks",
    rtlName: "ار تي ال",
    icon: "tim-icons icon-world",
    component: ListFeedbacks,
    layout: "/admin"
  },




];
export default routes;
